import { mapState, mapGetters } from 'vuex';

const validations = {
  data() {
    return {
      // eslint-disable-next-line
      validUsernameRegex: /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/,
      validPasswordRegex: /^[0-9]{0,8}$/,
      validEmailRegex: /^\S+@\S+\.\S+$/,
      validMsisdnRegex: /^[0-9]{0,20}$/,
      passwordOld: '',
      passwordNew: '',
      confirmPassword: '',
      username: '',
      usernameFb: '',
      proposedUsername: '',
      hasErrors: false,
      hasErrorsUsernameFb: false,
      resultMessage: '',
      success: false,
      msisdn: '',
      email: '',
      validateTexts: {
        username: {
          criteria: 'visitor_sign_up_3_warning_msg_username_criteria',
          blacklist: 'visitor_sign_up_3_warning_msg_username_blacklist_word',
          taken: 'visitor_sign_up_3_warning_msg_username_taken_below',
          sizeLimit: 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long',
        },
        password: {
          symbols: 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_',
          sizeLimit: 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars',
        },
        confirm: {
          noMatch: 'home_profile_profile_edit_msg_warning_entered_passwords_not_match',
        },
      },
    };
  },
  methods: {
    validateEmail() {
      this.hasErrors = !(this.validEmailRegex.test(this.email));
    },
    validateMsisdn() {
      let validMsisdnRegex = this.validMsisdnRegex;
      if (this.conversionForArabicFields) validMsisdnRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,20}$/;
      const validMsisdn = this.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.resultMessage = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.resultMessage = '';
      }
    },
    validateConfirmation(evt, min = 4, max = 4, isPin = true) {
      const { noMatch } = this.validateTexts.confirm || {};
      const { symbols } = this.validateTexts.password || {};
      if (this.confirmPassword) {
        const validPass = this.confirmPassword.match(isPin ? this.validPasswordRegex : this.validUsernameRegex);
        this.hasErrors = false;
        this.resultMessage = '';
        if (this.confirmPassword.length < min) {
          this.hasErrors = true;
        } else if (this.confirmPassword.length > max) {
          this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
          this.hasErrors = true;
          this.validateConfirmation(min, max, isPin);
        } else if (validPass !== null) {
          if (this.confirmPassword.length > max) {
            this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
            this.hasErrors = true;
            this.validateConfirmation(min, max, isPin);
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.resultMessage = noMatch || 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.resultMessage = symbols || 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
        }
      } else {
        this.hasErrors = false;
        this.resultMessage = '';
      }
    },
    validatePasswordOld(min = 4, max = 12) {
      if (this.passwordOld) {
        this.hasErrors = false;
        this.resultMessage = '';
        if (this.passwordOld.length < min || this.passwordOld.length > max) {
          this.resultMessage = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrors = true;
        }
      }
    },
    validatePassword(evt, min = 4, max = 4, isPin = true) {
      // eslint-disable-next-line
      const { symbols, sizeLimit } = this.validateTexts.password || {};
      const { noMatch } = this.validateTexts.confirm || {};
      if (this.passwordNew) {
        const validPass = this.passwordNew.match(isPin ? this.validPasswordRegex : this.validUsernameRegex);
        this.resultMessage = '';
        this.hasErrors = false;
        if (this.passwordNew.length < min) {
          this.resultMessage = sizeLimit;
          this.hasErrors = true;
        } else if (this.passwordNew.length > max) {
          this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
          this.hasErrors = true;
          this.validatePassword(evt, min, max, isPin);
        } else if (validPass !== null) {
          if (this.passwordNew.length > max) {
            this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
            this.hasErrors = true;
            this.validatePassword(evt, min, max, isPin);
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.resultMessage = noMatch;
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.resultMessage = symbols;
        }
      } else {
        this.hasErrors = false;
        this.resultMessage = '';
      }
    },
    validateUsername(evt, min = 3, max = 12) {
      // eslint-disable-next-line
      const {criteria, blacklist, taken, sizeLimit} = this.validateTexts.username;
      this.hasErrors = false;
      this.resultMessage = '';
      if (!this.username) {
        this.hasErrors = false;
      } else {
        // eslint-disable-next-line
        if (this.username.length < min) {
          this.resultMessage = sizeLimit;
          this.hasErrors = true;
        } else {
          if (this.username.length > max) {
            this.username = this.checkMaxChar(this.username, max, evt);
            this.hasErrors = true;
          }
          this.hasErrors = false;
          const validUsername = this.username.match(this.validUsernameRegex);
          if (validUsername === null) {
            this.hasErrors = true;
            this.resultMessage = criteria;
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.username}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}`).then((response) => {
            const res = response.data.data.msg;
            if (res === 'Username exists') {
              this.resultMessage = taken;
              this.hasErrors = true;
            } else if (res === 'Invalid') {
              this.hasErrors = true;
              this.resultMessage = blacklist;
            } else {
              this.resultMessage = response.data.data.msg;
            }
            this.proposedUsername = response.data.data.prpusn;
          });
        }
      }
    },
    validateFbUsername(evt, min = 3, max = 12) {
      // eslint-disable-next-line
      const {criteria, blacklist, taken, sizeLimit} = this.validateTexts.username || {};
      this.hasErrorsUsernameFb = false;
      this.resultMessage = '';
      if (!this.usernameFb) {
        this.hasErrorsUsernameFb = false;
      } else {
        // eslint-disable-next-line
        if (this.usernameFb.length < min) {
          this.resultMessage = sizeLimit || 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.hasErrorsUsernameFb = true;
        } else {
          if (this.usernameFb.length > max) {
            this.username = this.checkMaxChar(this.usernameFb, max, evt);
            this.hasErrorsUsernameFb = true;
          }
          this.hasErrorsUsernameFb = false;
          const validUsername = this.usernameFb.match(this.validUsernameRegex);
          if (validUsername === null) {
            this.hasErrorsUsernameFb = true;
            this.resultMessage = criteria || 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.usernameFb}&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}`).then((response) => {
            const res = response.data.data.msg;
            if (res === 'Username exists') {
              this.resultMessage = taken || 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrorsUsernameFb = true;
            } else if (res === 'Invalid') {
              this.hasErrorsUsernameFb = true;
              this.resultMessage = blacklist || 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            } else {
              this.resultMessage = response.data.data.msg;
            }
            this.proposedUsername = response.data.data.prpusn;
          });
        }
      }
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    clearMessages() {
      this.success = false;
      this.hasErrors = false;
      this.hasErrorsUsernameFb = false;
      this.resultMessage = '';
    },
    setResult(result) {
      this.resultMessage = result;
    },
    setError(error) {
      this.hasErrors = error;
    },
    setSuccess(success) {
      this.success = success;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'conversionForArabicFields',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getMessage() {
      if (this.resultMessage === 'SERVER_ERROR') return this.resultMessage;
      return this.getTranslations[this.resultMessage] || '';
    },
  },
};

export default validations;



// WEBPACK FOOTER //
// ./src/common/mixins/validations.js